import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class Environment extends Component
{

    one(){
        this.props.store.zeroevent = "one";
        this.forceUpdate();

    }

    two(){
        this.props.store.zeroevent = "two";
        this.forceUpdate();

    }

    three(){
        this.props.store.zeroevent = "three";
        this.forceUpdate();

    }

    four(){
        this.props.store.zeroevent = "four";
        this.forceUpdate();

    }

    five(){
        this.props.store.zeroevent = "five";
        this.forceUpdate();

    }
    six(){
        this.props.store.zeroevent = "six";
        this.forceUpdate();

    }

    seven(){
        this.props.store.zeroevent = "seven";
        this.forceUpdate();

    }
  
    render()
    {
        return <>  {this.props.store.zeroevent == "nothing" && <div className = "zerostart">
           既然你选了事件，那就来简单的讲解一下事件是什么<br/><br/>
           事件意味着变化，是描述一个状态“变化”成另一个状态的过程<br/>
           当别人问你今天怎么样，你说“无事发生”，是指今天和往常一样，没有任何变化。<br/><br/>

           因此在我们写一个基本事件时，最重要的就是把握好变化过程<br/>
           现在，我们先来写一个变化。<br/>
           什么变化都行，想写什么就写什么<br/>
           先写变化前的样子，再写变化后的样子<br/>
           最后，请用更多的字数，在中间写变化过程<br/>
           这就是一个事件。

           <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.one() } >写好了！</Button><br/>
        </div>}
        
        {this.props.store.zeroevent == "one" && <div className = "zerostart">
            一个随意的变化，当然不是好的故事事件。<br/>
            故事事件首先应该发生在人物身上。<br/><br/>
            
            先检查你的事件是不是发生在某个人物身上<br/>
            比如说下了一场大雨，并没有涉及到人<br/>
            下了场大雨，把某个人淋湿了，这才算是发生在人物身上。<br/>
            如果没有发生在人物身上，请改写你的事件。<br/>
            如果不知道怎么写人物，可以点击重选，先学习人物的部分<br/>

            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.two() } >写好了！</Button><br/>
            </div>}


            {this.props.store.zeroevent == "two" && <div className = "zerostart">
                
                接下来，是最重要的部分<br/><br/>
                这个变化不是轻易发生的，而是冲破了层层障碍，好不容易才发生的<br/>
                即使是一场大雨，也可以是干旱中求来的雨<br/>
                请想一想这个变化的障碍是什么，以及如何冲破障碍的。<br/>
                重写一下变化过程，重点是障碍和冲破障碍。

                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.three() } >写好了！</Button><br/>
            
                </div>}


            {this.props.store.zeroevent == "three" && <div className = "zerostart">
            写故事的要领，在于“冲突”<br/>
            也就是两股力量互相对抗。<br/>
            比如在这个变化中，让变化发生的是一股力量，阻碍变化发生的是另一股力量<br/>
            因为第一种力量，变化才可能发生。<br/>
            因为有第二种力量，变化才没有在之前，早早就发生了。<br/>
            也因为有第二种力量，变化过程才足够长，被我们观察到<br/><br/>
            
            
            所谓的冲突，就是两股力量互相较量的过程。<br/>
            通过设置势均力敌的两股力量，可以让冲突更加激烈，故事也容易写得精彩。<br/><br/>
            现在，你可以去修改一下你的故事，试着让两股力量都更强烈一些。
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.four() } >改完了！</Button><br/>
                </div>}



             {this.props.store.zeroevent == "four" && <div className = "zerostart">
             好呢！你已经写出了一个小故事了！<br/>
            是不是很简单呢~<br/><br/>
            怎么样，对自己写的小故事满意吗？
            <div className = "buttondiv">
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.five() } >还不错！</Button>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.six() } >不满意！</Button></div>
            
                 </div>}

            {this.props.store.zeroevent == "five" && <div className = "zerostart">
            那真是太棒了！<br/>
                 万事开头难，相信你会写得越来越好的<br/><br/>
                 下面是如何写得更好的小技巧：穷举<br/>
                 比如在确定变化，或者决定阻力的时候，不要想到一个，就开始写。<br/>
                 要尽可能多的想，比如想5~10个，然后再从里面选最好的一个<br/>
                 不管是好的还是坏的作者，脑子里出现的第一个想法，一般都是俗套的陈词滥调。<br/><br/>
                 但有经验的作者，有丰富的素材库，可以想到更多点子，也更有经验，能从中挑出最适合的<br/><br/>
                 素材和挑选经验，是需要后面慢慢积累的，不过写故事本身，也会帮助积累。<br/>
                 只要多写，多思考，在生活中遇到素材就会立刻发现，并记下来啦<br/>
                 如果都没有开始写，即使遇到了绝佳的素材，可能也发现不了呢<br/><br/>

                 总之，积累的事情以后再说<br/>
                 现在先用穷举法在你刚刚写完的故事中，再加个变化和阻力吧<br/>
                 再以这样的变化和阻力，写故事的续集<br/>
                 <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.seven() } >写好了！</Button>
                </div>}


                {this.props.store.zeroevent == "six" && <div className = "zerostart">
                是吗，但也不用气馁<br/>
                     毕竟万事开头难，谁也不是一开始就能写好的<br/><br/>
                     为了写得更好，可以使用一个小技巧：穷举<br/>

                     比如在确定变化，或者决定阻力的时候，不要想到一个，就开始写。<br/>
                 要尽可能多的想，比如想5~10个，然后再从里面选最好的一个<br/>
                 不管是好的还是坏的作者，脑子里出现的第一个想法，一般都是俗套的陈词滥调。<br/><br/>
                 但有经验的作者，有丰富的素材库，可以想到更多点子，也更有经验，能从中挑出最适合的<br/><br/>
                 素材和挑选经验，是需要后面慢慢积累的，不过写故事本身，也会帮助积累。<br/>
                 只要多写，多思考，在生活中遇到素材就会立刻发现，并记下来啦<br/>
                 如果都没有开始写，即使遇到了绝佳的素材，可能也发现不了呢<br/><br/>

                 总之，积累的事情以后再说<br/>
                 现在先用穷举法在你刚刚写完的故事中，再加个变化和阻力吧<br/>
                 再以这样的变化和阻力，写故事的续集<br/>
                 <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.seven() } >写好了！</Button>
                    </div>}

                {this.props.store.zeroevent == "seven" && <div className = "zerostart">
                恭喜！你已经完成了小故事写作的第一步！<br/>
                         千里之行始于足下，多写就会有进步的~<br/>
                         前面的练习和讲解挺多的，看完应该累了吧~可以稍微休息一下<br/><br/>

                         如果想要继续写，可以点击重选按钮。再次选择人物，场景，事件中的一个来写<br/><br/>
                         建议都尝试过，再进行下一步哦！<br/>
                         如果每一种都练习三遍，那就更好啦！<br/>
                         更多的练习，会让下一节课程更好懂，更有启发呢！<br/>

                         <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.props.history.push("/bigstory") } >下一步</Button>
                    </div>}
        
        </>;
    }
} 